import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {registrarOficio, GetEmisor, GetUltimoID,POSTCartilla, POSTCT, GetCatRequisitosCartillas, UPDCCE, UPDCTE, POSTCRQ, GetCRID, UPDCRQR} from '../../services/SecurityService';
import { DropdownList } from 'react-widgets';
import axios from "axios";
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom'
import {Modal,Button} from 'react-bootstrap'
import {isEmpty, isMail} from '../../config/helpers/Validations';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import EmisorIcon from '@material-ui/icons/AccountBoxRounded';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';




import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';

export default class RegistroOficio4 extends Component {
  constructor(props) {
    super(props);
  
  
    this.validateForm = this.validateForm.bind(this);
  

    this.onChangeNoFolio = this.onChangeNoFolio.bind(this);
this.onChangeNoOficio = this.onChangeNoOficio.bind(this);
this.onChangeFechaDocumento = this.onChangeFechaDocumento.bind(this);
this.onChangeFechaExpiracion = this.onChangeFechaExpiracion.bind(this);
//this.onChangeCategoria = this.onChangeCategoria.bind(this);
this.onChangePersona = this.onChangePersona.bind(this);
this.onChangenombre = this.onChangenombre.bind(this);
this.onChangetelefono = this.onChangetelefono.bind(this);
this.onChangedomicilio = this.onChangedomicilio.bind(this);
this.onChangerfc = this.onChangerfc.bind(this);
this.onChangecorreo = this.onChangecorreo.bind(this);
this.onChangeapoderado = this.onChangeapoderado.bind(this);
this.onChangecalle = this.onChangecalle.bind(this);
this.onChangeno = this.onChangeno.bind(this);
this.onChangecolonia = this.onChangecolonia.bind(this);
this.onChangecodigoPostal = this.onChangecodigoPostal.bind(this);
this.onChangelocalidad = this.onChangelocalidad.bind(this);
this.onChangeentreCalle = this.onChangeentreCalle.bind(this);
this.onChangeyCalle = this.onChangeyCalle.bind(this);
this.onChangeinversion = this.onChangeinversion.bind(this);
this.onChangeobservaciones = this.onChangeobservaciones.bind(this);
this.onChangedenominacionComercial = this.onChangedenominacionComercial.bind(this);
this.onChangetipoEstablecimiento = this.onChangetipoEstablecimiento.bind(this);

this.onChangemedidas = this.onChangemedidas.bind(this);
this.onChangeAforo = this.onChangeAforo.bind(this);
this.onChangerazonsocial = this.onChangerazonsocial.bind(this);
this.onChangeclavecatastral = this.onChangeclavecatastral.bind(this);

//this.onChangenombreNegocio = this.onChangenombreNegocio.bind(this);
//this.onChangetelefonoNegocio = this.onChangetelefonoNegocio.bind(this);



this.onChangeEmisor = this.onChangeEmisor.bind(this);
this.onChangeAsuntos = this.onChangeAsuntos.bind(this);
this.onChangeObservaciones = this.onChangeObservaciones.bind(this);
this.onChangePruebaEsta = this.onChangePruebaEsta.bind(this);

this.onChangeCMatricula = this.onChangeCMatricula.bind(this);
this.onChangeCApellidoPaterno = this.onChangeCApellidoPaterno.bind(this);
this.onChangeCApellidoMaterno = this.onChangeCApellidoMaterno.bind(this);
this.onChangeCNombre = this.onChangeCNombre.bind(this);
this.onChangeCFechaNacimiento = this.onChangeCFechaNacimiento.bind(this);
this.onChangeCClase = this.onChangeCClase.bind(this);
this.onChangeCLugarNacimiento = this.onChangeCLugarNacimiento.bind(this);

this.onChangeCNombrePadre = this.onChangeCNombrePadre.bind(this);

this.onChangeCNombreMadre = this.onChangeCNombreMadre.bind(this);
this.onChangeCTutor = this.onChangeCTutor.bind(this);
this.onChangeCEstadoCivil = this.onChangeCEstadoCivil.bind(this);
this.onChangeCOcupacion = this.onChangeCOcupacion.bind(this);
this.onChangeCLeerEscribir = this.onChangeCLeerEscribir.bind(this);
this.onChangeCCurp = this.onChangeCCurp.bind(this);
this.onChangeCNivelEstudios = this.onChangeCNivelEstudios.bind(this);
this.onChangeCGradoMaximo = this.onChangeCGradoMaximo.bind(this);
this.onChangeCDomicilio = this.onChangeCDomicilio.bind(this);
this.onChangeCFechaEntrega = this.onChangeCFechaEntrega.bind(this);
this.onChangeCFechaRegistro = this.onChangeCFechaRegistro.bind(this);

this.onSubmit = this.onSubmit.bind(this);
this.handleShow = this.handleShow.bind(this);
this.handleClose = this.handleClose.bind(this);
this.onChangeHandler = this.onChangeHandler.bind(this);
this.handleChange = this.handleChange.bind(this);

this.state = {
selectedFile: [],
      RD : "",
      NoFolio: '',
      NoOficio: '',
      obj : "",
      Categoria:'',
      Asuntos:'',
      Observaciones:'',
      FechaDocumento:'',
      FechaExpiracion:'',
      nombre:'',
      domicilio:'',
      telefono:'',
      medidas:'',
      Aforo:'',
      razonsocial:'',
      clavecatastral:'',
      //nombreNegocio:'',
      //telefonoNegocio:'',

      CMatricula:'',
      CApellidoPaterno:'',
      CApellidoMaterno:'',
      CNombre:'',
      CFechaNacimiento:'',
      CClase:'',
      CLugarNacimiento:'',
      CNombrePadre:'',
      CNombreMadre:'',
      CTutor:'',
      CEstadoCivil:'',
      COcupacion:'',
      CLeerEscribir:'NO',
      CCurp:'',
      CNivelEstudios:'',
      CGradoMaximo:'',
      CDomicilio:'',
      CFechaEntrega:'',
      CFechaRegistro:'',

      errNoFolio: '',
      errNoOficio: '',
      Categorias :[{descripcion : "SOLTERO", id :0},
      {descripcion : "CASADO", id :7},
      {descripcion : "DIVORCIADO", id :8},
      {descripcion : "VIUDO", id :9},
      
    ],
    show: false,
    Emisor : [],
    Persona :[{descripcion : "FISICA", id :"F"},
      {descripcion : "MORAL", id :"M"}
    ],
    redirect: "",
    Personas : "",
    value: "",
    value2 : "",
    value3 : "",

    giros : "",
    inversion:  "",
      rfc: "",
      calle: "",
      no: "",
      colonia: "",
      codigoPostal: "",
      localidad: "",
      entreCalle: "",
      yCalle: "",
      denominacionComercial: "",
      tipoEstablecimiento: "",
      apoderado : "",
      correo: "",



      req:[],

      req1:false,
      req2:false,
      req3:false,
      req4:false,
      req5:false,
      req6:false,
      req7:false,


      
    }
    
  }

  componentDidMount(){
    console.log("el  usuario")
    console.log(this.state.userD)
   

    



  GetCRID({id_tramite:this.props.obj.id_tramite}).then(response => {
    console.log(response)

    if(response!="No existen clientes en la BBDD."){
this.setState({
      req1:response[0].valor ? true : false,
      req2:response[1].valor? true : false,
      req3:response[2].valor? true : false,
      req4:response[3].valor? true : false,
      req5:response[4].valor? true : false,
      req6:response[5].valor? true : false,
      req7: this.props.obj.lugar_nac.toUpperCase().includes('TEPIC') !=undefined ? this.props.obj.lugar_nac.toUpperCase().includes('TEPIC') : '' ? false : response[6].valor ,
      req:response
})
}
}).catch(err => console.log(err));  
}

validateForm(){
  let valid=true, errNoFolio="", errNoOficio="";
  if(isEmpty(this.state.NoFolio)){
    errNoFolio = "Campo de Folio, esta vacío";
    valid=false;
  }

  if(isEmpty(this.state.NoOficio)){
    errNoOficio = "Campo de Oficio, esta vacío";
    valid=false;
  }
  if(!valid){
    this.setState({errNoFolio: errNoFolio, errNoOficio: errNoOficio});
  }
  return valid;
}

onChangeNoFolio(e) {
  this.setState({
  NoFolio: e.target.value
  });
  }
  onChangenombre(e) {
  this.setState({
  nombre: e.target.value
  });
  }
  onChangedomicilio(e) {
  this.setState({
  domicilio: e.target.value
  });
  }
  onChangetelefono(e) {
  this.setState({
  telefono: e.target.value
  });
  }
  onChangeNoOficio(e) {
  this.setState({
  NoOficio: e.target.value
  }) 
  }
  onChangerfc(e) {
  this.setState({
  rfc: e.target.value
  }) 
  }
  onChangecorreo(e) {
  this.setState({
  correo: e.target.value
  }) 
  }
  onChangeapoderado(e) {
  this.setState({
  apoderado: e.target.value
  }) 
  }
  onChangecalle(e) {
  this.setState({
  calle: e.target.value
  }) 
  }
  onChangeno(e) {
  this.setState({
  no: e.target.value
  }) 
  }
  onChangecolonia(e) {
  this.setState({
  colonia: e.target.value
  }) 
  }
  onChangecodigoPostal(e) {
  this.setState({
  codigoPostal: e.target.value
  }) 
  }
  onChangelocalidad(e) {
  this.setState({
  localidad: e.target.value
  }) 
  }
  onChangeentreCalle(e) {
  this.setState({
  entreCalle: e.target.value
  }) 
  }
  onChangeyCalle(e) {
  this.setState({
  yCalle: e.target.value
  }) 
  }
  onChangeinversion(e) {
  this.setState({
  inversion: e.target.value
  }) 
  }
  onChangeobservaciones(e) {
  this.setState({
  observaciones: e.target.value
  }) 
  }
  onChangemedidas(e) {
    this.setState({
    medidas: e.target.value
    });
    }
    onChangeAforo(e) {
      this.setState({
      Aforo: e.target.value
      });
      }
      onChangerazonsocial(e) {
        this.setState({
        razonsocial: e.target.value
        });
        }
        onChangeclavecatastral(e) {
          this.setState({
          clavecatastral: e.target.value
          });
          }
          onChangeCMatricula(e) {
            this.setState({
            CMatricula: e.target.value
            });
            }
            onChangeCApellidoPaterno(e) {
              this.setState({
                CApellidoPaterno: e.target.value
              });
              }
              onChangeCApellidoMaterno(e) {
                this.setState({
                  CApellidoMaterno: e.target.value
                });
                }
                onChangeCNombre(e) {
                  this.setState({
                    CNombre: e.target.value
                  });
                  }
                  onChangeCFechaNacimiento(e) {
                    this.setState({
                      CFechaNacimiento: e.target.value
                    });
                    }
                    onChangeCClase(e) {
                      const value = e.target.value.toUpperCase();
                    
                      // Limitar a 4 caracteres
                      if (value.length <= 4) {
                        this.setState({
                          CClase: value,
                        });
                      }
                    }
                  onChangeCLugarNacimiento(e) {
                    this.setState({
                      CLugarNacimiento: e.target.value
                    });
                    }
                    onChangeCNombrePadre(e) {
                      this.setState({
                        CNombrePadre: e.target.value
                      });
                      }onChangeCNombreMadre(e) {
                        this.setState({
                          CNombreMadre: e.target.value
                        });
                        }onChangeCTutor(e) {
                          this.setState({
                            CTutor: e.target.value
                          });
                          }onChangeCEstadoCivil(e) {
                            this.setState({
                              CEstadoCivil: e.target.value
                            });
                          }onChangeCOcupacion(e) {
                            this.setState({
                              COcupacion: e.target.value
                            });
                          }onChangeCLeerEscribir(e) {
                            this.setState({
                              CLeerEscribir: e.target.value
                            });
                          }onChangeCCurp(e) {
                            this.setState({
                              CCurp: e.target.value
                            });
                          }onChangeCNivelEstudios(e) {
                            this.setState({
                              CNivelEstudios: e.target.value
                            });
                          }onChangeCGradoMaximo(e) {
                            this.setState({
                              CGradoMaximo: e.target.value
                            });
                          }onChangeCDomicilio(e) {
                            this.setState({
                              CDomicilio: e.target.value
                            });
                          }onChangeCFechaEntrega(e) {
                            this.setState({
                              CFechaEntrega: e.target.value
                            });
                           } onChangeCFechaRegistro(e) {
                              this.setState({
                                CFechaRegistro: e.target.value
                              });
                            }

      
      

  /*
onChangenombreNegocio(e) {
        this.setState({
        nombreNegocio: e.target.value
        });
        }
        onChangetelefonoNegocio(e) {
          this.setState({
          telefonoNegocio: e.target.value
          });
          }
  */
  onChangedenominacionComercial(e) {
  this.setState({
  denominacionComercial: e.target.value
  }) 
  }
  onChangetipoEstablecimiento(e) {
  this.setState({
  tipoEstablecimiento: e.target.value
  }) 
  }
  onChangeEmisor(descripcion) {
  console.log(descripcion);
  let { Emisor} = this.state;
  
  let newOption = descripcion;
  
  this.setState({
  value2: newOption, 
  Emisor: [...Emisor],
  otro2: Emisor.filter(tipo => tipo.toLowerCase().includes(descripcion.toLowerCase()))
  })
  }
  onChangeCEstadoCivil(descripcion) {
  console.log(descripcion);
  let { Categorias} = this.state;
  
  let newOption = descripcion;
  
  this.setState({
  value: newOption, 
  Categorias: [...Categorias],
  otro: Categorias.filter(tipo => tipo.descripcion.toLowerCase().includes(descripcion.descripcion.toLowerCase()))
  })
  }
  
  onChangePersona(descripcion) {
  console.log(descripcion);
  let { Persona} = this.state;
  
  let newOption = descripcion;
  
  this.setState({
  value3: newOption, 
  Persona: [...Persona],
  otro: Persona.filter(tipo => tipo.descripcion.toLowerCase().includes(descripcion.descripcion.toLowerCase()))
  })
  }
  
  onChangeAsuntos(e) {
  this.setState({
  Asuntos: e.target.value
  })
  }
  onChangeObservaciones(e) {
  this.setState({
  Observaciones: e.target.value
  })
  }
  onChangeFechaDocumento(e) {
  this.setState({
  FechaDocumento: e.target.value
  })
  }
  onChangeFechaExpiracion(e) {
  this.setState({
  FechaExpiracion: e.target.value
  })
  }
  
  onChangePruebaEsta(e) {
  this.setState({
  selectedFile: e.target.value
  })
  }
  
  onChangeHandler(e){
  
  this.setState({
  selectedFile: e.target.files[0]
  })
  }
  
  onClickHandler() {
  const data = new FormData()
  data.append('fileStg', this.state.selectedFile)
  console.log("Esta daga<<")
  console.log(this.state.selectedFile)
  console.log(this.state.selectedFile.name)
  
  // axios.post("http://cartillas-apis.herokuapp.com/postfile", data)
  // .then(response => alert(response.data))
  // .catch(err => alert(err.toString()));
  }
  
  handleClose() {
  this.setState({ show: false });
  }
  
  handleShow() {
  this.setState({ show: true });
  }
  
  fechaNombre(fecha){
    let fN=fecha.substring(0,10);
    let fnn="";
    
    let af=fN.split("-");
    
    fnn=af[2]+" DE ";
    
    if(af[1]=="01"){
      fnn=fnn+"ENERO DE "
    }else if(af[1]=="02"){
      fnn=fnn+"FEBRERO DE "
    }
    else if(af[1]=="03"){
      fnn=fnn+"MARZO DE "
    }
    else if(af[1]=="04"){
      fnn=fnn+"ABRIL DE "
    }
    else if(af[1]=="05"){
      fnn=fnn+"MAYO DE "
    }
    else if(af[1]=="06"){
      fnn=fnn+"JUNIO DE "
    }
    else if(af[1]=="07"){
      fnn=fnn+"JULIO DE "
    }
    else if(af[1]=="08"){
      fnn=fnn+"AGOSTO DE "
    }
    else if(af[1]=="09"){
      fnn=fnn+"SEPTIEMBRE DE "
    }
    else if(af[1]=="10"){
      fnn=fnn+"OCTUBRE DE "
    }
    else if(af[1]=="11"){
      fnn=fnn+"NOVIEMBRE DE "
    }
    else if(af[1]=="12"){
      fnn=fnn+"DICIEMBRE DE "
    }
    
    fnn=fnn+af[0];
    return fnn;
    }

  onSubmit(e) {
    e.preventDefault();
 //   this.onClickHandler();

let a =[]
let n=0;
if(this.state.req1){
a.push({id_tramite:this.props.obj.id_tramite,id_requisito:1,valor:true})
}else{
  a.push({id_tramite:this.props.obj.id_tramite,id_requisito:1,valor:false})
  n++;
}
if(this.state.req2){
  a.push({id_tramite:this.props.obj.id_tramite,id_requisito:2,valor:true})
  }else{
    a.push({id_tramite:this.props.obj.id_tramite,id_requisito:2,valor:false})
    n++;
  }
  if(this.state.req3){
    a.push({id_tramite:this.props.obj.id_tramite,id_requisito:3,valor:true})
    }else{
      a.push({id_tramite:this.props.obj.id_tramite,id_requisito:3,valor:false})
      n++;
    }
    if(this.state.req4){
      a.push({id_tramite:this.props.obj.id_tramite,id_requisito:4,valor:true})
      }else{
        a.push({id_tramite:this.props.obj.id_tramite,id_requisito:4,valor:false})
        n++;
      }
      if(this.state.req5){
        a.push({id_tramite:this.props.obj.id_tramite,id_requisito:5,valor:true})
        }else{
          a.push({id_tramite:this.props.obj.id_tramite,id_requisito:5,valor:false})
          n++;
        }
        if(this.state.req6){
          a.push({id_tramite:this.props.obj.id_tramite,id_requisito:6,valor:true})
          }else{
            a.push({id_tramite:this.props.obj.id_tramite,id_requisito:6,valor:false})
            n++;
          }
          if(this.props.obj.lugar_nac.toUpperCase().includes('TEPIC') !=undefined ? 
          !this.props.obj.lugar_nac.toUpperCase().includes('TEPIC') : false){
          if(this.state.req7){
            a.push({id_tramite:this.props.obj.id_tramite,id_requisito:7,valor:true})
            }else{
              a.push({id_tramite:this.props.obj.id_tramite,id_requisito:7,valor:false})
              n++;
            }
          }
            console.log(this.props.obj);
console.log(a);
console.log(n);

    const obj = {
     
     id_preregistro:this.props.obj.id_preregistro,
     id_estatus:n>0 ? 2 : 3,
     id_usuario:this.props.id_usuario,
   

    };
    console.log("cartilla obj");
    console.log(obj);



    const newArray = [];

// Iterar sobre los elementos de array1
a.forEach(item1 => {
    // Buscar coincidencias en array2
    const matchingItem = this.state.req.find(item2 => item2.id_tramite === item1.id_tramite && item2.id_requisito === item1.id_requisito);
    if (matchingItem) {
        // Crear un nuevo objeto con los datos combinados
        const combinedItem = {
            id_tramite: item1.id_tramite,
            id_requisito: item1.id_requisito,
            id_cartillas_requisitos: matchingItem.id_cartillas_requisitos,
            valor: item1.valor
        };
        // Agregar el objeto al nuevo array
        newArray.push(combinedItem);
    }
});

// Imprimir el nuevo array
console.log(newArray);
   
    
    UPDCTE(obj).then(response => {
     
      console.log("Aqui ese supone q se registro")
      console.log(response);

      let nn=0;
newArray.forEach(function(element, index){
  
 
  

  UPDCRQR(element).then(response => {
    nn++;
  
    console.log(response);
 console.log("contador : "+nn);
    
    
     
      if(nn==a.length){
     
     
      alert("Proceso Terminado ! ");
  window.location.reload();
     
        }

}).catch(err => console.log(err)); 

}) 

     // window.location.reload();
     if(response=="Nuevo registro guardado."){
     alert("Registro Guardado!");
     window.location.reload();}
    }).catch(err => console.log(err)); 
    
   
  }

  renderRedirect = () => {
    if (this.state.redirect=="F") {
      return <Redirect to={'/oficios/RegistroDocumentos1/' + this.state.obj}/>
    }
    else if(this.state.redirect=="M"){
      return <Link to='/oficios/RegistroDocumentos2'/>
    }
  }

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };
  render() {


    let { value, Categorias, value2, Emisor, value3, Persona, Giro} = this.state;

    
    return (
        <div style={{ marginTop: 10 }}>
            
            <form onSubmit={this.onSubmit}>
              
          
                <div className="form-group">
                  <hr></hr>
                <Grid container spacing={2} >

                      <Grid item xs={12}>
                      <center>
                      <FormControl component="fieldset" >
        <FormLabel component="legend">REQUISITOS</FormLabel>
        <FormGroup>
        <FormControlLabel
            control={<Checkbox checked={this.state.req1} onChange={this.handleChange} name="req1" color='primary'/>}
            label="Acta de Nacimiento Original y copia"
          />
       <FormControlLabel
            control={<Checkbox checked={this.state.req2} onChange={this.handleChange} name="req2" color='primary'/>}
            label="4 Fotografias de estudio"
          />
            <FormControlLabel
            control={<Checkbox checked={this.state.req3} onChange={this.handleChange} name="req3" color='primary'/>}
            label="Comprobante de domicilio reciente (luz, agua o teléfono)"
          />
            <FormControlLabel
            control={<Checkbox checked={this.state.req4} onChange={this.handleChange} name="req4" color='primary'/>}
            label="Certificado máximo grado de estudios o constancia de estudio"
          />
            <FormControlLabel
            control={<Checkbox checked={this.state.req5} onChange={this.handleChange} name="req5" color='primary'/>}
            label="CURP (Formato Nuevo)"
          />
            <FormControlLabel
            control={<Checkbox checked={this.state.req6} onChange={this.handleChange} name="req6" color='primary'/>}
            label="Credencial del INE"
          />
           {this.props.obj.lugar_nac !=undefined ? this.props.obj.lugar_nac.toUpperCase().includes('TEPIC')  ? null :  <FormControlLabel
            control={<Checkbox checked={this.state.req7} onChange={this.handleChange} name="req7" color='primary'/>}
            label="Constancia de No Registro"
          /> : null} 
        </FormGroup>
      </FormControl>
      </center>
                      </Grid>
                      
             

         
           
                
                    </Grid>
                </div>
              
                      
                
               
               
                {/*
                <label>Copia comprobante de domicilio de negocio: </label>
                      <input type="file" name="file" onChange={this.onChangeHandler} />
                 
               
                <a rel="noopener noreferrer" href={"http://intranet.tepic.gob.mx/archivoscartillas/"+this.state.Observaciones} target="_blank">Link Here</a>
                */}
               
                
               
                       
                <>
            
      
                <Modal 
               size="lg"
               aria-labelledby="contained-modal-title-vcenter"
               dialogClassName="modal-90w"
               centered
              show={this.state.show} onHide={this.handleClose} centered>
                <Modal.Header closeButton>
                <Modal.Title>Documentos Persona : {this.state.Personas }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
               
               
                <this.state.RD obj={this.state.obj}/>
               
              
                </Modal.Body>
                
              </Modal>
            </>
            <div className="form-group">
                  <hr style={{width:'100%'}}></hr>
                    <input style={{backgroundColor:'#A02142',borderRadius:'8px',float:'right',borderColor:'#A02142'}} type="submit" value="GUARDAR" className="btn btn-primary"/>
                </div>

                
               
            </form>
        </div>
    )
  }
}